import React, { Component } from 'react';
import config from 'react-global-configuration';

// Importação do Router
import { BrowserRouter, Route, Switch, Link, Redirect} from 'react-router-dom';
// Importação do Bootstrap
import { Button, Modal, Grid, Row, Col, Navbar, NavItem, Nav, MenuItem, NavDropdown } from 'react-bootstrap';
// Importação da tabela
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import Loading from '../Miscelania/Loading';
// Helpers de formulário
import Topo from '../Layout/Topo';
import InputMask from 'react-input-mask';
import Select from 'react-select';
import RequestApi from '../Miscelania/RequestApi';
import Overlay from '../Miscelania/Overlay';


class ConfiguracoesQuestoesDificuldade extends Component {
  // Handlers de form
  handleChange (name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
  } 
  handleSelectChange(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event.value;
    }
    this.setState(change);
  }
  handleMessage () {
    var message = localStorage.getItem("verify_message");
    if (message !== null && typeof message !== 'undefined') {
      message = JSON.parse(message);
      var self = this;
      self.setState({overlay: {message: message.alert_message, type: message.alert_type, status: 'open'}});
      localStorage.removeItem("verify_message");
    }
  }
  handleAlert(message, type, status, mode) {
    if(mode === 'reset') {
      this.setState({overlay: {message: '', type: '', status: 'closed'}});
    } else {
      this.setState({overlay: {message: message, type: type, status: status}});
    }
  }

  handleLoaded(state) {
    if(this.state.loaded !== 2) {
      this.setState({loaded: state});      
    }
  }
  // constructor
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'open',        
      },
      redirect_url: false,
      loaded: 0,
      modal: false,
      name: '',
      name_edit: '',
      id_edit: '',
      dados: [],
    };
    //bind geral
    // handleChange e handleChangeSelect necessitam do bind nas tags
    this.handleAlert = this.handleAlert.bind(this);
    this.handleLoaded = this.handleLoaded.bind(this);
    this.handleMessage = this.handleMessage.bind(this);

    this.loadData = this.loadData.bind(this);
    this.adicionarDificuldade = this.adicionarDificuldade.bind(this);
    this.showModal = this.showModal.bind(this);
    this.botaoEdicao = this.botaoEdicao.bind(this);
    this.editarDificuldade = this.editarDificuldade.bind(this);
  }

  componentDidMount () {
    this.refs.request_api.header();
  }

  componentDidUpdate(prevProps, prevState) {
    if(this.state.loaded === 1 && prevState.loaded === 0) {
      this.setState({loaded: 2}, this.loadData());
    }
  }
  loadData(e) {
    var url = config.get('api') + '/questoes/dificuldades';
    var header = this.refs.request_api.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'url', '/categorias');
        if (responseJson.status === 'success') {
          self.setState({dados: responseJson.data});
        }
      }).then(() => {
        self.setState({overlay: {message: '', type: '', status: 'closed'}});
        self.handleMessage();
      });
    });
  }


  adicionarDificuldade(event) {
    event.preventDefault();
    this.handleAlert('', '', 'open');

    var dados_salvar = {
      name: this.state.name,
    };

    var header = this.refs.request_api.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/questoes/dificuldades/adicionar', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(dados_salvar) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson);
        if (responseJson.status === 'success') {
          var dados_temp = self.state.dados;
          dados_temp.push(responseJson.data);
          self.setState({dados: dados_temp});        
        }
        self.handleAlert(responseJson.message, responseJson.status, 'open');
      }).catch((error) => {
        console.error(error);
      });
    });
  }


  editarDificuldade(event) {
    event.preventDefault();
    this.handleAlert('', '', 'open');

    var dados_salvar = {
      id: this.state.id_edit,
      name: this.state.name_edit,
    };

    var header = this.refs.request_api.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/questao/dificuldade/editar', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(dados_salvar) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson);
        if (responseJson.status === 'success') {
          self.setState({ modal: false });
          self.setState({dados: responseJson.data});
        }
        self.handleAlert(responseJson.message, responseJson.status, 'open');
      }).catch((error) => {
        console.error(error);
      });
    });


  }


  showModal(event) {
    var target = event.currentTarget.value;
    this.handleAlert('', '', 'open');

    var url = config.get('api') + '/questao/dificuldade/view/'+target;
    var header = this.refs.request_api.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      fetch(url, { method: 'GET', mode: 'cors', headers: value}).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson);
        if (responseJson.status === 'success') {
          self.setState({ modal: true });
          self.setState({
            id_edit: target,
            name_edit: responseJson.data.name,
          });
          self.handleAlert('', '', 'closed');
        }
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  botaoEdicao (cell, row) {
    var botao = (
      <button className="btn btn-primary btn-sm" value={cell} onClick={this.showModal}>
        <i className="fa fa-fw fa-pencil"></i>
      </button>
    );

    return botao;
  }

  render() {
    return (
<div>
  <Topo></Topo>
  <RequestApi ref={'request_api'} handleLoaded={this.handleLoaded} />
  <Overlay overlay={this.state.overlay} handleAlert={this.handleAlert} />
  <div className="container">
    <div className="conteudo">
      <div className="row">
        <div className="col-md-5">
          <h3 className="page-title">Cadastrar dificuldade de questão</h3>
          <hr/>
          <form onSubmit={this.adicionarDificuldade}>
            <div className="form-group">
              <label>Nome:</label>
              <input type="text" name="name" className="form-control" placeholder="Nome da dificuldade" value={this.state.name} onChange={this.handleChange.bind(this, 'name')} />
            </div>     
            <div className="form-group">
              <button className="btn btn-primary btn-block" type="submit"><i className="fa fa-fw fa-save"></i> Adicionar dificuldade</button>
            </div>
          </form>
        </div>      
        <div className="col-md-7">
          <h3 className="page-title">Lista de dificuldades de questões</h3>
          <hr/>
          <BootstrapTable data={this.state.dados} pagination={true} striped={true} hover={true} exportCSV={true} options={{exportCSVText: 'Exportar CSV', sizePerPage: 100, noDataText: 'Não há dificuldade de questão cadastrada'}} search={true} multiColumnSearch={true}  searchPlaceholder='Procurar'>

            <TableHeaderColumn dataField="name" isKey={true} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: ' '}} width='300'>Nome</TableHeaderColumn>

            <TableHeaderColumn dataField="id" dataAlign="center" dataFormat={this.botaoEdicao} width='80'>Ações</TableHeaderColumn>

          </BootstrapTable>
        </div>
      </div>
    </div>
  </div>
  <Modal show={this.state.modal} aria-labelledby="contained-modal-title-lg">
    <Modal.Header>
      <h4 className="pull-left">Editar dificuldade de questão</h4>
      <button className="btn btn-danger btn-sm pull-right" onClick={()=>this.setState({ modal: false })}>
      <i className="fa fa-fw fa-close"></i></button>
      <div className="clearfix"></div>
    </Modal.Header>
    <Modal.Body>
      <form onSubmit={this.editarDificuldade}>
        <input type="hidden" name="id" className="form-control" value={this.state.id_edit} />
        <div className="form-group">
          <label>Nome:</label>
          <input type="text" name="name" className="form-control" placeholder="Nome da dificuldade" value={this.state.name_edit} onChange={this.handleChange.bind(this, 'name_edit')} />
        </div>     
        <div className="form-group">
          <button className="btn btn-primary btn-block" type="submit"><i className="fa fa-fw fa-save"></i> Editar dificuldade</button>
        </div>
      </form>
    </Modal.Body>
    <Modal.Footer>
      <button className="btn btn-danger btn-sm pull-right" onClick={()=>this.setState({ modal: false })}>
      <i className="fa fa-fw fa-close"></i></button>
    </Modal.Footer>
  </Modal>
</div>
    );
  }
}

export default ConfiguracoesQuestoesDificuldade;



// WEBPACK FOOTER //
// ./src/Components/Configuracoes/ConfiguracoesQuestoesDificuldade.js